import React from 'react';

const NgBenefitsSection = () => {
  const channels = [
    { name: 'WhatsApp', logo: '/whatsapp-logo.png' },
    { name: 'SMS', logo: '/sms-logo.png' },
    { name: 'Facebook', logo: '/facebook-logo.png' },
    { name: 'Instagram', logo: '/instagram-logo.png' },
  ];

  const benefits = [
    {
      title: '3–5× higher open rates',
      body: 'Every WhatsApp and SMS feels like it was written for that one customer — so they actually read and respond.',
      accent: 'bg-[#8ae690]/15 border-[#8ae690]/40',
    },
    {
      title: 'Customers texting you “Thank you”',
      body: 'Instead of blasting generic promos, you’re sending helpful reminders and relevant offers that feel personal.',
      accent: 'bg-white border-gray-200',
    },
    {
      title: 'Reorder revenue you never knew existed',
      body: 'The AI nudges customers at the perfect moment with the perfect incentive — turning one-off buyers into loyal regulars.',
      accent: 'bg-white border-gray-200',
    },
    {
      title: 'Ad costs drop while ROAS climbs',
      body: 'You retarget warm buyers with exact offers they already love — not cold audiences that waste your budget.',
      accent: 'bg-white border-gray-200',
    },
    {
      title: 'Hours back every week',
      body: 'Campaigns, segments, and creatives run on autopilot, so you can focus on stock, staff, and serving customers.',
      accent: 'bg-gray-50 border-gray-200',
    },
    {
      title: 'Confidence in every naira you spend',
      body: 'See exactly which flows, nudges, and ads are printing money — and which ones to turn off.',
      accent: 'bg-white border-gray-200',
    },
  ];

  return (
    <section id="benefits" className="py-12 sm:py-16 md:py-20 bg-white overflow-hidden">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mb-8">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-black/70 mb-3">
            Outcomes
          </p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold tracking-tight text-black mb-3">
            Imagine waking up to a business that sells for you.
          </h2>
          <p className="text-base sm:text-lg text-gray-700 leading-relaxed">
            This isn’t “marketing” — it’s your data finally working for you instead of sitting there useless.
          </p>
        </div>

        <div className="grid gap-6 lg:grid-cols-[0.9fr_1.1fr] items-start">
          <div className="rounded-[2rem] border border-black bg-black text-white px-6 py-7 shadow-[0_24px_60px_-24px_rgba(0,0,0,0.35)]">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-white/70 mb-4">
              What growth feels like
            </p>
            <h3 className="text-2xl sm:text-3xl font-bold tracking-tight mb-4">
              More repeat customers. Less guessing. Better margins.
            </h3>
            <p className="text-sm sm:text-base text-white/85 leading-relaxed mb-6">
              Kolanut.ai helps you turn transaction history into the kind of follow-up customers actually want to receive.
            </p>

            <div className="grid grid-cols-2 gap-3">
              <div className="rounded-2xl bg-white/10 border border-white/10 px-4 py-4">
                <p className="text-xs text-white/70 mb-1">Average lift</p>
                <p className="text-2xl font-bold text-white">3.4×</p>
              </div>
              <div className="rounded-2xl bg-white/10 border border-white/10 px-4 py-4">
                <p className="text-xs text-white/70 mb-1">Time to first wins</p>
                <p className="text-2xl font-bold text-white">72 hrs</p>
              </div>
              <div className="rounded-2xl bg-white/10 border border-white/10 px-4 py-4 col-span-2">
                <p className="text-xs text-white/70 mb-1">Channels working together</p>
                <p className="text-lg font-semibold text-white">
                  WhatsApp + SMS + Facebook/Instagram ads
                </p>
                <div className="flex flex-wrap items-center gap-2.5 mt-3">
                  {channels.map((channel) => (
                    <div
                      key={channel.name}
                      className="inline-flex items-center gap-2 rounded-2xl bg-white/10 border border-white/10 px-3 py-2"
                    >
                      <img
                        src={channel.logo}
                        alt={`${channel.name} logo`}
                        className="h-6 w-auto object-contain"
                      />
                      <span className="text-xs font-semibold text-white/90">{channel.name}</span>
                    </div>
                  ))}
                </div>
                {/* <p className="text-[11px] text-white/60 mt-3">
                  Assumed asset paths: `public/whatsapp-logo.png`, `public/sms-logo.png`, `public/facebook-logo.png`,
                  `public/instagram-logo.png`
                </p> */}
              </div>
            </div>
          </div>

          <div className="grid gap-4 sm:grid-cols-2">
            {benefits.map((benefit, index) => (
              <div
                key={benefit.title}
                className={`rounded-[1.75rem] border px-5 py-5 shadow-sm ${benefit.accent} ${
                  index === 2 || index === 5 ? 'sm:col-span-2' : ''
                }`}
              >
                <div className="flex items-start gap-3">
                  <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-black text-sm font-bold text-white">
                    {index + 1}
                  </div>
                  <div>
                    <h3 className="text-base font-semibold text-black mb-1">
                      {benefit.title}
                    </h3>
                    <p className="text-sm text-gray-700 leading-relaxed">
                      {benefit.body}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default NgBenefitsSection;

